import { Module } from 'vuex'
import { RootState, Collection } from '../store-types'
import { MetaPayload } from '@/core/utils/pagination'
import { useHealthArticleHttp } from '@/core/api/health-articles'
import { HealthArticle, HealthArticlePayload } from '@/core/models/health-article'

export type HealthArticleCollection = {
    data: Array<HealthArticle>,
    meta?: MetaPayload,
    links?: any
}

const state: HealthArticleCollection = {
    data: <any>[],
    meta: <any>[],
    links: <any>[],
}

export const healthArticleCollection: Module<HealthArticleCollection, RootState> = {
    namespaced: true,
    state,
    mutations: {
        set: (state: HealthArticleCollection, payload: Collection) => {
            state.data = <any>[]
            payload.data.forEach((item: HealthArticlePayload) => {
                state.data.push(new HealthArticle(item))
            })
            state.meta = payload.meta
            state.links = payload.links
        },
    },
    actions: {
        get: <T>(context: any, payload: any): Promise<T> => {
            return new Promise<T>((resolve, reject) => {
                useHealthArticleHttp()
                    .get(payload)
                    .then((data: any) => {
                        context.commit('set', data)
                        resolve(data as T)
                    })
                    .catch((response: any) => {
                        reject(response as T)
                    })
            })
        }
    },
    getters: {
        get: (state: HealthArticleCollection): HealthArticleCollection => {
            return state
        }
    }
}